module.exports = __webpack_public_path__ + "static/media/47.8cf514a0.jpg";